import api from '@rental-manager/utils/api';

const StaticMapActions = {
  signUrl(url, params) {
    return (dispatch) =>
      dispatch(api.users.signUrl(url, params))
        .then((response) => {
          if (response.success === false) {
            // error
            return Promise.reject({
              message: `ERROR: Request to sign url @ ${url}`,
            });
          }
          // success
          return response.signedUrl;
        })
        .catch((error) => Promise.reject(error.message));
  },
};

export default StaticMapActions;
